import React, { FC } from 'react'

import { useTheme } from '@mui/material'
import TableCell from '@mui/material/TableCell'

export const TableHeadCell: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { palette, spacing } = useTheme()
  return (
    <TableCell
      sx={{
        fontFamily: 'Arial, sans-serif',
        color: palette.grey[700],
        maxWidth: spacing(38),
        fontSize: { xs: 12, md: 14 },
        fontWeight: 800,
        textAlign: 'right',
        padding: spacing(1.125),
        flexDirection: 'row-reverse',
        borderBottom: 'none',
      }}
    >
      {children}
    </TableCell>
  )
}
